import { MapWorkspacePermissionType } from './map-workspace-permission';

export interface PermissionDTO {
    defaultPermission: MapWorkspacePermissionType;
    permissions: {
        id: string;
        type: PermissionType;
        name: string;
        permission: MapWorkspacePermissionType;
    }[];
}

// Example: "FULL_ACCESS": ["users:xxxxxx-xxxxb-4xx0-8xxb-xx6a", "users:xxxxxxx-xxx-4f2xx1-bxx0a9-bxxx1xx42"]
type AccessControlList = Partial<Record<MapWorkspacePermissionType, string[]>>;

export interface PermissionSettings {
    defaultAccess: MapWorkspacePermissionType;
    acl: AccessControlList;
    inheritance?: boolean;
}

export interface FolderPermissionsResponse {
    directPermissions: PermissionSettings;
    inheritedPermissions: PermissionSettings;
}

export enum PermissionType {
    USER = 'ConnectUser',
    GROUP = 'ConnectGroup',
    USER_LEGACY = 'USER',
    GROUP_LEGACY = 'GROUP'
}

export const permissionPriority = {
    [MapWorkspacePermissionType.FULL_ACCESS]: 0,
    [MapWorkspacePermissionType.READ]: 1,
    [MapWorkspacePermissionType.NO_ACCESS]: 2,
    [MapWorkspacePermissionType.NO_FILE_ACCESS]: 3,
    [MapWorkspacePermissionType.FILE_VIEW_MODE]: 4
};

export class Permission {
    // DTO properties
    defaultPermission: MapWorkspacePermissionType = null;
    permissions: { id: string; type: PermissionType; name: string; permission: MapWorkspacePermissionType }[] = [];

    // Added properties
    effectivePermission: MapWorkspacePermissionType; // effective permission for current user
}
